var React = require('react');

function Cancel (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fill-none stroke-foreground"},[React.createElement("line",{"strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.4","y1":"5.7","x2":"17.8","y2":"18","key":0}),React.createElement("line",{"strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"5.4","y1":"18","x2":"17.8","y2":"5.7","key":1})]));
}

Cancel.defaultProps = {"version":"1.0","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Cancel;

Cancel.default = Cancel;
